<script>
import LandingPageMixin from '@/mixins/landingpage'

export default {
  name: 'LandingPageCostsaver',
  mixins: [ LandingPageMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false
    }
  },
  methods: {
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    }
  }
}
</script>

<style lang="scss" scoped>
// @import './font-effra.scss';
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="cover navbar page-header-drawer menu-right logo-left topmenu-right" >
      <!-- START cover -->
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo gg" src="/landingpages/costsaver/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>
    </header>
    <!-- END OF site header Menu-->
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu" >
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="text show-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Close</span>
          <span class="text hide-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Menu</span>
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle  animated delay-1s slow fadeIn hidePlease">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo white" :class="{ 'displayLogo': !isMenuToggle }" src="/landingpages/costsaver/img/logo.png" alt="Logo">
              <img class="light-logo blue" :class="{ 'displayLogo': isMenuToggle }" src="/landingpages/costsaver/img/logo-blue.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="overlaymdwhite" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#letter" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('letter')">Description</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#highlight" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('highlight')">Highlights</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->
    <!-- BEGIN OF page main content -->
    <main class="scrollWeblink page-main main-anim scrollpage-container animated fadeIn" id="mainpage" >
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        id="home" :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': 'url(/landingpages/costsaver/img/bg-style-1.jpg)'}]">
        <div class="section-wrapper">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description">

                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                      <i v-if="Array.isArray(d.itineraries.locations_visited) == true" class="fa fa-map-marker ml-2"></i>
                      <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.consumer_section">
                      {{ d.consumer_section.trip_name }}
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.consumer_section">
                        <span>{{ d.consumer_section.trip_subtitle }}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section letter" data-section="letter" id="letter" >
        <div class="section-wrapper yellow letter-host with-margin">
          <div class="tour_host_box" v-if="d.consumer_section.tour_host_photo">
            <img class="tour_host_photo" :src="d.consumer_section.tour_host_photo"/>
            <div class="tour_host_info">
              <p class="tour_host_name" v-if="d.consumer_section.tour_host_name" v-html="d.consumer_section.tour_host_name"></p>
              <p v-if="d.consumer_section.tour_host_position" v-html="d.consumer_section.tour_host_position"></p>
            </div>
          </div>
           <span class="tour_host_box" v-if="!d.consumer_section.tour_host_photo"></span>
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
              <div
                class="title-desc anim-4 paddig-container letter-box">
                <div v-html="d.consumer_section.short_description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section section-itinerary" data-section="itinerary" id="itinerary" >
        <div class="section-wrapper">
          <div class="section-content anim">

            <div class="col-12 col-lg-12 anim top_blue cover-header-description-title2 blue">
              <div class="title-desc">
                <h2 class="h2">Itinerary</h2>
              </div>
            </div>

            <div class="row row-random grid-media-aside-text fade-3">
                <div
                class="border-card"
                :class="{'col-md-6' : index != Object.keys(d.itineraries.days).length - 1 ||index === Object.keys(d.itineraries.days).length - 1 && Object.keys(d.itineraries.days).length % 2 === 0,
                'col-md-12' : index === Object.keys(d.itineraries.days).length - 1 && Object.keys(d.itineraries.days).length % 2 !== 0}"
                v-for="(day, index) in d.itineraries.days"
                :key="index" @click="dayScrollTo(index)">
                  <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/landingpages/costsaver/img/day-img.jpg"/>
                    <div class="info">
                      <div class="text-inside">
                        <h1>DAY {{ day.startday }}</h1>
                        <p class="subtitle" v-html="day.title"></p>
                        <p class="date">
                          <i class="icon fa fa-calendar mr-2"></i>
                          <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                        </p>
                        <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                          <i class="fa fa-map-marker mr-2"></i>
                          <span >{{ day.locations | custom-join('name') }}</span>
                        </p>
                        <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday">
                          <span v-html="day.textday[0].textday.substring(0,265)+'...'"></span>
                          <span href='#' data-toggle='modal' class='underlineLink'> Show more</span>
                        </p>
                        <p v-if="day.meals">
                          <strong class="mr-1">MEAL(S):</strong>
                          <span>{{ day.meals | custom-join('mealsday') }}</span>
                        </p>
                        <p v-if="day.accommodation">
                          <strong class="mr-1">HOTEL:</strong>
                          <span>{{ day.accommodation}}</span>
                        </p>

                      </div>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->
      <!-- Begin of description section -->
      <div class="section fullscreen-md-off no-footer bg-level-4 "
        data-section="highlight" id="highlight"
        v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0 ||
        Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">

        <div class="section-wrapper yellow2 blue2 with-margin section-included">
          <div class="section-content anim paddig-container">
            <div class="title-desc">
              <h2 class="h2 blue">Included</h2>
            </div>
            <div class="row">
              <div class="col-12 col-md-6  text-left">
                <div
                  class="section-info white "
                  v-if="Array.isArray(d.consumer_section.whatsincluded) && d.consumer_section.whatsincluded.length > 0">
                  <div v-for="whatsinc in d.consumer_section.whatsincluded" :key="whatsinc.id">
                    <h3 v-html="whatsinc.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in whatsinc.items" :key="item.id">
                        <span v-if="item.items.split(':').length > 1">
                          <strong
                            v-if="item.items.split(':')[0]"
                            v-html="`${item.items.split(':')[0]}:`"></strong>
                        </span>
                        <span v-else>{{ item.items.split(':')[0] }}</span>
                        <span
                          v-if="item.items.split(':')[1]"
                          v-html="` ${item.items.split(':')[1]}`"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6  text-left">
                <div
                  class="section-info white "
                  v-if="Array.isArray(d.consumer_section.highlights) && d.consumer_section.highlights.length > 0">
                  <div v-for="highlight in d.consumer_section.highlights" :key="highlight.id">
                    <h3 v-html="highlight.title"></h3>
                    <ul class="mb-4">
                      <li v-for="item in highlight.items" :key="item.id">
                          <div v-if="item.items.indexOf(':') == -1">
                              <strong
                                v-if="item.items.substr(0,item.items.indexOf(' '))"
                                v-html="item.items.substr(0,item.items.indexOf(' '))"></strong>
                              <span
                                v-if="item.items.substr(item.items.indexOf(' ')+1)"
                                v-html="` ${item.items.substr(item.items.indexOf(' ')+1)}`"></span>
                          </div>

                          <div v-else>
                            <span v-if="item.items.split(':').length > 1">
                              <strong
                                v-if="item.items.split(':')[0]"
                                v-html="`${item.items.split(':')[0]}:`"></strong>
                            </span>
                            <span v-else v-html="item.items.split(':')[0]"></span>
                            <span
                              v-if="item.items.split(':')[1]"
                              v-html="` ${item.items.split(':')[1]}`"></span>
                          </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of description section -->

      <div class="section content-white bg-level-2 bg-mark" data-section="map" id="map" >
        <img v-if="secondOpporunityBackgroundImage != '' " :src="`${secondOpporunityBackgroundImage}`" alt="">
        <img v-else src="/landingpages/costsaver/img/blank.png" alt="">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="h2 anim-2">Map</h2>
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
              </div>
              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of description section -->
      <div class="section fullscreen-md-off no-footer bg-level-4 " data-section="prices" id="prices" >
        <div class="section-wrapper yellow  blue with-margin">
          <div class="section-content anim paddig-container">
              <div class="row">
                <div class="col-12 col-md-12 text-left">
                    <div class="title-desc">
                      <h2 class="h2 blue">Pricing</h2>
                    </div>
                    <div class="section-info white pr-4 table_pricing">
                     <div class="row">
                      <div class="col-12 col-md-6 anim">
                    <div class="title-desc amount-price" v-if="d && d.consumer_section">
                      <p class="display-5 anim-2">Twin Share Price</p>
                      <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.twinshare_price }}</h2>
                    </div>
                      </div>
                      <div class="col-12 col-md-6 anim fluid contact-info-right">
                        <div class="contact-us-box">
                      <div class="title-desc amount-price" v-if="d && d.consumer_section">
                        <p class="display-5 anim-2">Single Supplement Price</p>
                        <h2 class="display-5 anim-2 text-center pb-0">{{ d.consumer_section.single_supp_price }}</h2>
                      </div>
                      </div>
                 </div>
               </div>
                </div>
                <p class="terms">View <a href="#" @click.prevent="toggleTermsAndConditionsModal"><strong>Terms and Conditions</strong></a></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of contact section-->
      <div class="section section-contact bg-level-2  bg-mark " data-section="contact" id="contact" >
        <img v-if="thirdOpporunityBackgroundImage != '' " :src="`${thirdOpporunityBackgroundImage}`" alt="">
        <img v-else src="/landingpages/costsaver/img/contact.jpg">
        <div class="section-wrapper with-margin">
            <div class="section-content paddig-container">
              <div class="row">
                <div class="col-12 col-md-6 anim contact-info contact-info-left ">
                  <div class="title-desc">
                    <h2 class="display-5 anim-2 text-center h2">Contact Us</h2>
                  </div>
                 <div class="pt-1">
                  <p class="pt-4 text-center" v-if="!d.consumer_section && !d.consumer_section.company_logo">
                    Contact your Travel Agent!
                    </p>
                     <p class="pt-4 text-center" v-if="!d.consumer_section.call_action">
                      Please send a message.
                    </p>
                    <p class="call_action-info" v-if="d.consumer_section.call_action" v-html="d.consumer_section.call_action"></p>
                    <img class="tour_host_logo" v-if="d.consumer_section.company_logo" :src="d.consumer_section.company_logo"/>
                  </div>
                </div>

                <div class="col-12 col-md-6 anim contact-info contact-info-right fluid contact-border-left">
                  <div class="contact-us-box">
                    <div class="title-desc">
                      <h2 class="display-5 anim-2 h2">Message Us Directly</h2>
                    </div>
                    <form  @submit.prevent="sendContactForm">
                      <div class="form-group ">
                        <input class="form-control-white" type="text" required placeholder="Your Name" v-model="name" :disabled="isSending">
                      </div>
                      <div class="form-group ">
                        <input class="form-control-white" type="email" required placeholder="Your Email" v-model="email" :disabled="isSending">
                      </div>
                      <div class="form-group ">
                        <textarea class="form-control-white" type="text" required placeholder="Description" cols="10" rows="10" v-model="description" :disabled="isSending"></textarea>
                      </div>
                      <div class="form-group form-success-gone text-right mb-0 d-flex justify-content-end align-items-center">
                        <div v-if="isCompleted">{{ message }}</div>
                        <button class="btn btn-outline-white form-success-gone mb-0 ml-2" type="submit" :disabled="isSending">
                          <strong class="text" v-if="!isSending">Send</strong>
                          <strong class="text" v-else>Sending</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <footer >
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/landingpages/costsaver/img/logo-itp.png" width="80">
          </div>
           <div class="detail">All rights reserved: ©Global Encounters™ 1999-2021</div>
        </div>
      </footer>
    </main>

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
    <div
      class="modal modal-fullscreenTC fade"
      id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalTermsAndConditionsToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalTermsAndConditionsToggle">
      <div class="overlaymd" @click="toggleTermsAndConditionsModal"></div>
      <div class="section-header">
        <img class="light-logo" src="/landingpages/costsaver/img/logo.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title-desc"><h3 data-v-60697b22="" class="h2 dark-blue">Terms & Conditions</h3></div>
            <div
              class="title-desc anim-4 paddig-container scrollable scrollv2"
              v-html="d.consumer_section.terms_conditions">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal  modal-fullscreen fade modalDays"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <i class="fa fa-chevron-left" @click="toggleModal"></i>
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body mt-5">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/landingpages/costsaver/img/day-img.jpg"/>
                  <div class="section_text_overlay">
                    <h1>DAY {{ index + 1}}</h1>
                    <p class="subtitle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">
                  <div class="align-vcenter">
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                      <i class="fa fa-map-marker mr-2"></i>
                      <span >{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation}}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday" >
                    <a class="down" href="#section02">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
